/*
 * CAMORI 再塗装無料キャンペーン: オプション商品の自動カート投入
 *
 * sales.repaint が true の商品がカートにある間、再塗装オプション(#86613)を
 * 同数量だけ自動で同居させる。割引は camori-functions 側の Function が行うため、
 * ここは「対象商品の合計数量ぶんオプションが入っている」状態を維持するだけ。
 *
 * カート明細から商品メタフィールドはJSで読めないので、判定材料は
 * sections/camori-repaint-state.liquid が返すJSONに集約している。
 *
 * 自動追加した行には _repaint_auto プロパティを付ける。お客さまが自分で
 * 追加した分(manualQty)は触らず、不足分だけを自動側で補う。
 */
(function () {
  const STATE_SECTION = 'camori-repaint-state';
  const AUTO_PROPERTY = '_repaint_auto';

  let inFlight = false;
  let rerunRequested = false;

  function rootUrl() {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  }

  async function fetchState() {
    const res = await fetch(`${rootUrl()}?section_id=${STATE_SECTION}`);
    if (!res.ok) return null;
    const html = await res.text();
    const holder = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('[data-camori-repaint-state]');
    if (!holder) return null;
    try {
      return JSON.parse(holder.textContent);
    } catch (e) {
      console.error('[repaint-option] 状態JSONの解析に失敗', e);
      return null;
    }
  }

  /* 再描画が必要なセクション。カートページ以外ではカートアイコンのみ。 */
  function sectionsToRender() {
    const sections = [];
    const items = document.getElementById('main-cart-items');
    const footer = document.getElementById('main-cart-footer');

    if (items) sections.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
    sections.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    if (footer) sections.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });

    return sections;
  }

  function applySections(parsedState, sections) {
    if (!parsedState || !parsedState.sections) return;

    sections.forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;
      const html = parsedState.sections[section.section];
      if (!html) return;

      const replace = target.querySelector(section.selector) || target;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
      if (source) replace.innerHTML = source.innerHTML;
    });
  }

  async function postCart(url, payload, sections) {
    const body = JSON.stringify({
      ...payload,
      sections: sections.map((section) => section.section),
      sections_url: window.location.pathname,
    });

    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    });
    return res.json();
  }

  async function reconcile() {
    if (inFlight) {
      rerunRequested = true;
      return;
    }
    inFlight = true;

    try {
      const state = await fetchState();
      if (!state || !state.optionVariantId) return;

      /* 対象商品が無くなったら「不要」の意思表示も役目を終える。
         次に対象商品を入れたときは、また標準で付く状態に戻す */
      if (state.declined && state.targetQty === 0) {
        await postCart(window.routes.cart_update_url, { attributes: { 再塗装: '' } }, []);
      }

      /* 無料になるのは対象商品の合計数量まで。手動追加分を差し引いた不足分を自動側で持つ。
         「不要」と言われている間は足さない */
      const desired = state.declined ? 0 : Math.max(0, state.targetQty - state.manualQty);
      if (desired === state.autoQty) return;

      const sections = sectionsToRender();
      let result = null;

      if (state.autoKey) {
        result = await postCart(window.routes.cart_change_url, { id: state.autoKey, quantity: desired }, sections);
      } else if (desired > 0) {
        if (!state.optionAvailable) return;
        result = await postCart(
          window.routes.cart_add_url,
          { items: [{ id: state.optionVariantId, quantity: desired, properties: { [AUTO_PROPERTY]: '1' } }] },
          sections
        );
      }

      applySections(result, sections);
    } catch (e) {
      /* 失敗してもカート自体は壊さない。Function側は同居していなければ割引しないだけ */
      console.error('[repaint-option] カートの同期に失敗', e);
    } finally {
      inFlight = false;
      if (rerunRequested) {
        rerunRequested = false;
        reconcile();
      }
    }
  }

  /*
   * 自動投入した行の削除は「再塗装は不要」という意思表示。放っておくと直後の
   * 整合処理が入れ直してしまうので、削除と同時にカート属性へ記録する。
   * 削除と記録を1リクエストにまとめて、間に整合処理が割り込む余地をなくしている。
   * 属性は注文にも残るので、倉庫側が「この個体は塗らない」と判別できる。
   */
  async function decline(key, button) {
    const sections = sectionsToRender();
    try {
      const result = await postCart(
        window.routes.cart_update_url,
        { updates: { [key]: 0 }, attributes: { 再塗装: '不要' } },
        sections
      );
      applySections(result, sections);
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'camori-repaint-option' });
    } catch (e) {
      console.error('[repaint-option] 再塗装の辞退に失敗', e);
      /* 記録できなかったときは通常の削除に委ねる(入れ直される可能性は残る) */
      if (button) button.click();
    }
  }

  function onRemoveClick(event) {
    if (!event.target.closest) return;
    const button = event.target.closest('cart-remove-button');
    if (!button) return;
    const row = button.closest('[data-repaint-auto]');
    if (!row || !row.dataset.repaintKey) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    decline(row.dataset.repaintKey, button);
  }

  function start() {
    reconcile();
    document.addEventListener('click', onRemoveClick, true);
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => reconcile());
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
